export default async (cardUuid?: string, message?: string): Promise<void> => {
  if (!cardUuid) {
    return;
  }
  const body: any = {
  };
  if (message) {
    body.error_message = message;
  }
  await fetch(`${process.env.REACT_APP_REST_API_ADDRESS}/api/v1/mobigrams/${cardUuid}/card_failed_to_load`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  }).then((res) => res.json());
};
